
import Vue, {PropType} from "vue";
import axios from "axios";
import { MessengerEditorMode } from "../../../enums/Messaging/MessengerEditorMode";
import { UserMessage, User, KeyValuePairOfIntegerAndString, MessageSenderVM, EventType, TwoFacType, PatientDocumentFile, UserSearchData, UserMessagePriority } from '../../../types/Sapphire_dto';
import PatientSearch from '../../components/shared/PatientSearch.vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { size, ext } from "vee-validate/dist/rules";
import Editor from '@tinymce/tinymce-vue'

extend("size", {
    ...size,
    message: "The file size cannot be greater than 10MB."
});

extend("ext", {
    ...ext,
    message: "The file needs to be an accepted file extension."
});


export default Vue.extend({
    name: "message-sender",
    props: {
        fac: String,
        message: Object as PropType<UserMessage>,
        messageMode: Number as PropType<MessengerEditorMode>,
        usr: String
    },
    components: {
        PatientSearch,
        ValidationProvider,
        'editor': Editor
    },
    data: function () {
        return {
            chkPatInactive: false,
            chkPatReleased: false,
            chkPatTransferred: false,
            MessengerEditorMode,
            facRoles: [] as KeyValuePairOfIntegerAndString[],
            uploadFiles: [] as File[],
            files: [] as PatientDocumentFile[],
            msg: Object() as UserMessage,
            priorities:[
                { text: "Normal", value: "1", buttonVariant: "primary"},
                { text: "Urgent", value: "2", buttonVariant: "danger" },
            ],
            recipientOptions: [] as UserSearchData[],
            recipients: [] as User[],
            selectedFacRole: null,
            selectedPatient: Object() as KeyValuePairOfIntegerAndString,
            selectedPriority: UserMessagePriority.Normal,
            selectedRecip: null,
            selectedType: null as KeyValuePairOfIntegerAndString,
            types: [{ Key: 1, Value: 'General' }, { Key: 2, Value: 'Billing' }, { Key: 3, Value: 'Inventory' }, { Key: 4, Value: 'MAR' }, { Key: 5, Value: 'MedPass' }, { Key: 6, Value: 'Patient' }, { Key: 7, Value: 'Queues' }, { Key: 8, Value: 'Reporting' }] as KeyValuePairOfIntegerAndString[],
            ReplyFormat: "<br /><br /><p style='font-size:10px;'><span style='font-weight:bold;'>On {0} {1} said:</span><div style='min-height:25px; font: 10px/12px normal helvetica, sans-serif; margin-top: 10px; margin-bottom: 10px; margin-left: 25px; padding-left: 15px; border-left: 3px solid #ccc; border-top:none; border-right:none; border-bottom:none;'>{2}</div></p>",
            ForwardFormat: "<br /><br /><p style='font-size:10px;'><span style='font-weight:bold;'>Forwarded Message Details on {0} from {1}:</span><div style='min-height:25px; font: 10px/12px normal helvetica, sans-serif; margin-top: 10px; margin-bottom: 10px; margin-left: 25px; padding-left: 15px; border-left: 3px solid #ccc; border-top:none; border-right:none; border-bottom:none;'>{2}</div></p>",
            patSelectedWarning: false,
        };
    },
    mounted: function () {
        this.getFacilityRoles();
        this.loadMessage();
    },
    watch: {
        selectedRecip: function (newVal) {

            var vm = this;

            if (newVal == null)
                return;

            if (!vm.addRecip(newVal)) {
                this.$swal('Recipient Warning', newVal.displayName + ' is already a recipient.', 'warning');
            }

            // window.setTimeout(function () { vm.$refs.vsRecip.clearSelection(); }, 250)

        },
        uploadFiles: function (newVal: File[]) {
            if (newVal == null )
                return;
            
            this.files = newVal.map(f => { 
                let newPatDoc: PatientDocumentFile = {
                    FileName: f.name, 
                    FilePath: "", 
                    DownloadURL: "", 
                    ECSObjectKeyPath: "",
                    PatientDocumentID: 0,
                    ID: 0,
                    FileSize: 0,
                    Deleted: false
                    };
                return newPatDoc;
            });
        }
    },
    methods: {
        patientSelected(pat: KeyValuePairOfIntegerAndString) {
            //console.log("in method in MessageSender.vue")
            this.selectedPatient = pat ;
        },
        addRecip: function (recip: User) {

            if (!this.recipients.some(function (o) { return (o.UserID == recip.UserID) ; })) {
                this.recipients.push(recip);
                return true;
            } else {
                return false;
            }

        },
        async addRecipsByRegion(localOnly: boolean) {

            var vm = this;
            var method = 'GetUsersAssignedToRole';

            if (vm.selectedFacRole == null) {
                this.$swal('Recipient Warning', 'Please choose a role.', 'warning');
                return;
            }

            if (localOnly)
                method = 'GetUsersAssignedToRoleLocalOnly';

            const response = await axios.post("../../Common/Services/EMARClientOperations.svc/" + method,
            {
                selectedRoleID: this.selectedFacRole.Key
            });
            let allRecips: User[] = JSON.parse(response.data.d);
            allRecips.forEach( r => { this.addRecip(r); })

        },
        cancel: function () {
            this.$emit('hidesender');
        },
        clearRecipSearch: function () {
            this.selectedRecip = new Object as User;
        },
        // formatSentDate: function (dte: Date) {
        //     // var dateToFormat = new Date(parseInt(dte.substr(6)));
        //     return moment(dte).tz('America/New_York').format("MMM Do YY, hh:mm A");
        // },
        async getFacilityRoles() {
            const response = await axios.post("../../Common/Services/EMARClientOperations.svc/GetFacilityRoles");
            this.facRoles = JSON.parse(response.data.d);
        },
        loadMessage: function () {
            if (this.message != null) {
                //  NEED TO GET A *COPY/CLONE* of tm, *DO NOT* JUST MAKE IT EQUALS.
                this.msg = JSON.parse(JSON.stringify(this.message));

                if (this.msg.PatientID > 0) {
                    this.selectedPatient = { Key: this.msg.PatientID, Value: this.msg.PatientName };
                }

                if (this.msg.MessageBody.length > 0) {
                    this.msg.MessageBody = this.parseMessageBody(this.msg.MessageBody);
                }

                var senderStr = String.stringFormat("{0} {1} ({2})", this.msg.SenderFirstName, this.msg.SenderLastName, this.msg.SenderUserName);

                switch (this.messageMode) {
                    case MessengerEditorMode.ReplyAll:
                        this.msg.Subject = "RE: " + this.msg.Subject;

                        this.msg.MessageRecipients.forEach( r => { this.addRecip(r); });

                        this.addRecip({
                            FirstName: this.msg.SenderFirstName,
                            LastName: this.msg.SenderLastName,
                            MiddleName: this.msg.SenderMidName,
                            UserID: this.msg.SenderID,
                            DefaultLanndingPageId: 0,
                            ActiveFacilityID: 0,
                            AuditLogID: 0,
                            IsNeededNonFormularyAlerts: false,
                            PrescriberID: 0,
                            RegionID: 0,
                            HighestApprovalTier: 0,
                            IsLocked: false,
                            IsPharmacist: false,
                            IsInternal: false,
                            IsMultiregion: false,
                            DoNotPromptFacilitySwitch: false,
                            DefaultToSummaryView: false,
                            DefaultDashboard: 0,
                            LastEventID: EventType.Undefined,
                            ForcePasswordChange: false,
                            LoggedInUserID: 0,
                            LastModifiedBy: 0,
                            LastModifiedDate: undefined,
                            QueuesViewOnly: false,
                            IsDisabled: false,
                            DefaultOrderPrescriberID: 0,
                            CredentialID: 0,
                            isEPCSApproved: false,
                            isEPCSLocked: false,
                            isEPCSChangePending: false,
                            DEAExpiration: undefined,
                            SSO_ENABLED: false,
                            EPCSCurrentUserSetting: false,
                            TwoFacType: TwoFacType.Disabled,
                            DisableFormRespNotifications: false
                        });

                    this.msg.MessageBody = String.stringFormat(this.ReplyFormat, this.msg.DateSent.toLocaleString("en-US", {timeZone: "America/New_York"}), senderStr, this.msg.MessageBody);

                    break;
                    case MessengerEditorMode.Reply:

                        this.msg.Subject = "RE: " + this.msg.Subject;

                        this.addRecip({
                            FirstName: this.msg.SenderFirstName,
                            LastName: this.msg.SenderLastName,
                            MiddleName: this.msg.SenderMidName,
                            UserID: this.msg.SenderID,
                            DefaultLanndingPageId: 0,
                            ActiveFacilityID: 0,
                            AuditLogID: 0,
                            IsNeededNonFormularyAlerts: false,
                            PrescriberID: 0,
                            RegionID: 0,
                            HighestApprovalTier: 0,
                            IsLocked: false,
                            IsPharmacist: false,
                            IsInternal: false,
                            IsMultiregion: false,
                            DoNotPromptFacilitySwitch: false,
                            DefaultToSummaryView: false,
                            DefaultDashboard: 0,
                            LastEventID: EventType.Undefined,
                            ForcePasswordChange: false,
                            LoggedInUserID: 0,
                            LastModifiedBy: 0,
                            LastModifiedDate: undefined,
                            QueuesViewOnly: false,
                            IsDisabled: false,
                            DefaultOrderPrescriberID: 0,
                            CredentialID: 0,
                            isEPCSApproved: false,
                            isEPCSLocked: false,
                            isEPCSChangePending: false,
                            DEAExpiration: undefined,
                            SSO_ENABLED: false,
                            EPCSCurrentUserSetting: false,
                            TwoFacType: TwoFacType.Disabled,
                            DisableFormRespNotifications: false
                        });

                    this.msg.MessageBody = String.stringFormat(this.ReplyFormat, this.msg.DateSent.toLocaleString("en-US", {timeZone: "America/New_York"}), senderStr, this.msg.MessageBody);
                    break;

                    case MessengerEditorMode.Forward:

                        this.msg.Subject = "FW: " + this.msg.Subject;

                        this.msg.MessageBody = String.stringFormat(this.ForwardFormat, this.msg.DateSent.toLocaleString("en-US", {timeZone: "America/New_York"}), senderStr, this.msg.MessageBody);

                        this.files = this.msg.FileAttachmentList;

                        break;

                }

                var msgTypes = this.types.filter(t => { return t.Key == this.msg.MessageType });
                if (msgTypes.length == 1)
                    this.selectedType = msgTypes[0];

                this.selectedPriority = this.msg.Priority;

            } else {
                this.msg.DateSent = null;
                this.msg.MessageBody = '';
                this.msg.MessageID = 0;
                this.msg.MessageType = null;
                this.msg.Priority = null;
                this.msg.ReplyToMessageID = 0;
                this.msg.SenderFirstName = '';
                this.msg.SenderID = null;
                this.msg.SenderKeep = false;
                this.msg.SenderLastName = '';
                this.msg.SenderMidName = '';
                this.msg.Subject = '';
                this.msg.ThreadRootMessageID = 0;
                this.msg.PatientID = null;
                this.msg.SelectedRecipients = [];
                this.msg.PatientName = '';
                this.msg.SenderUserName = '';
                this.msg.MessageRecipients = [];
                this.msg.RecipientKept = false;
                this.msg.RecipientReadDate = null;
                this.msg.FileAttachmentList = [];
            }

        },
        async recipSearch(query) { 
            if( query.length >= 3 ) {
                const response = await axios.post("../../Common/Services/EMARClientOperations.svc/GetRegionUsers",
                {
                    prefixText: query

                });
                this.recipientOptions.splice(0);
                this.recipientOptions = response.data.d;
            }

        },
        parseMessageBody: function (encodedHTML: string) {
            var dp = new DOMParser;
            var dom = dp.parseFromString(encodedHTML, "text/html");
            if (dom && dom.body && dom.body.textContent && dom.body.textContent.length > 0) {
                return dp.parseFromString(dp.parseFromString(dom.body.textContent, "text/html").body.textContent, "text/html").body.textContent;
            } else {
                return '';
            }
        },
        removeRecip: function (recip) {
            this.recipients.splice(this.recipients.indexOf(recip), 1);
        },
        async send() {
             var warning = '';
             //var patSelectedWarning = false;

            if (this.recipients.length == 0) {
                warning += 'At least one recipient is required.\n';
            }
            if (this.msg.Subject.length == 0) {
                warning += 'A subject is required.\n';
            }
            if (this.selectedPriority == null) {
                warning += 'A priority is required.\n';
            }
            if (this.selectedType == null || this.selectedType.Key == 0) {
                warning += 'A type is required.\n';
            }

            if (warning.length > 0) {

                // this.$swal('Missing Required Fields', warning, 'warning');
                this.$swal({
                title: "Missing Required Fields",
                html: warning,
                icon: "warning",
                });
                return;

            }

            if (this.selectedPatient != null && this.selectedPatient.Key > 0 && this.patSelectedWarning == false) {
               
               this.$swal({
                title: "Patient Selected! this message will go on the Patient's record",
                html: warning,
                icon: "warning",
                });
                this.patSelectedWarning = true;
                return;
            }

            
            let msgVM = new Object as MessageSenderVM;

            msgVM._FileAttachmentList = this.files;
            msgVM._MessageBody = this.msg.MessageBody;
            msgVM._MessageID = 0;
            msgVM._MessageMode = this.messageMode;
            msgVM._MessageRecipients = this.recipients;
            msgVM._MessageType = this.selectedType.Key;
            if (this.selectedPatient != null && this.selectedPatient.Key > 0) {
                msgVM._PatientID = this.selectedPatient.Key;
                msgVM._PatientName = this.selectedPatient.Value;
            }
            msgVM._Priority = this.selectedPriority;
            msgVM._ReplyToMessageID = this.msg.MessageID;
            msgVM._Subject = this.msg.Subject;
            msgVM._ThreadRootMessageID = this.msg.ThreadRootMessageID != 0 ? this.msg.ThreadRootMessageID : this.msg.MessageID;

            let formData = new FormData();
            formData.append('data', JSON.stringify(msgVM));

            for( var i = 0; i < this.uploadFiles.length; i++ ){
                let file = this.uploadFiles[i];
                formData.append('Files[' + i + ']', file);
            }            

            await axios.post("../../Common/Services/EMARClientOperations.svc/SendMessageVue", 
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            this.patSelectedWarning = false;
            this.$emit('refresh', 1, 10);
            this.$emit('hidesender');
            
        },
        resetValidation() {
        (this.$refs.MessageSenderValidation as InstanceType<typeof ValidationObserver>).reset();
    },

    }
});

